export const AssetsActivitiesTypeTypeEnum = {
  lookupActivityCategory: 1201,
  lineManagerNotificationTemplateCategoriesId: 21809,
  SuperAdminNotificationTemplateCategoriesId: 21808,
  ClientNotificationTemplateCategoriesId: 60537,
  TeamLeadNotificationTemplateCategoriesId: 60538,
  AssignToNotificationTemplateCategoriesId: 21810,
  CreatedFromNotificationTemplateCategoriesId: 21820,
};
